import React from "react"

import {LexicalEditor} from "lexical"
import VScroll from "../../../../../../../scrolling/custom-v-scroll/v-scroll"
import {BadgeType, INSERT_BADGE_COMMAND} from "../../../../../highlight/badge/badge-plugin"
import {FontColorType, INSERT_FONT_COLOR_COMMAND} from "../../../../../highlight/font-color/font-color-plugin"
import ToolbarColorMenu_Options from "./menu-options"

type Props = {
    menuParams: {
        clearColorOptions   : Option[]
        fontColorOptions    : Option[]
        badgeColorOptions   : Option[]
        editor              : LexicalEditor
    }
    hidePopover : callback
}

// const debug = "ToolbarColorMenu"
const debug = false

export default function ToolbarColorMenu(props:Props) {

    const onClick = (value:any):void => {
        props.hidePopover()

        /*let styles:any = {}
        if (_.values(LexicalFontColor).includes(value)) {
            styles = getLexicalFontColorStyles(value)
        } else if (_.values(LexicalBGColor).includes(value)) {
            styles = getLexicalBGColorStyles(value)
        }

        let convertedStyles:any = {}
        if (styles.color)           convertedStyles['color']            = styles.color
        if (styles.backgroundColor) convertedStyles['background-color'] = styles.backgroundColor

        debug && console.log(debug, 'onClick', value, convertedStyles)

        lexicalApplyStyleText(props.menuParams.editor, convertedStyles)*/

        if (!value) {
            props.menuParams.editor.dispatchCommand(INSERT_FONT_COLOR_COMMAND, null)
            props.menuParams.editor.dispatchCommand(INSERT_BADGE_COMMAND, null)
        } else {
            if (_.values(FontColorType).includes(value)) {
                props.menuParams.editor.dispatchCommand(INSERT_FONT_COLOR_COMMAND, value)
            }

            if (_.values(BadgeType).includes(value)) {
                props.menuParams.editor.dispatchCommand(INSERT_BADGE_COMMAND, value)
            }
        }
    }

    return (
        <div className="ui5-popover-menu icon-fs-16" style={{minWidth:180}}>
            <VScroll containerClass="max-h-300" scrollVisibility="auto">
                <ToolbarColorMenu_Options optionClassName   = "w-100-percent border-box"
                                          options           = {props.menuParams.clearColorOptions}
                                          onClick           = {onClick}/>

                <div className="flex-row-left-center">
                    <div className="flex-column-left-top">
                        <ToolbarColorMenu_Options options={props.menuParams.fontColorOptions} onClick={onClick}/>
                    </div>
                    <div className="flex-column-left-top">
                        <ToolbarColorMenu_Options options={props.menuParams.badgeColorOptions} onClick={onClick}/>
                    </div>
                </div>
            </VScroll>
        </div>
    )
}